import Disclosure from "../utils/Disclosure.js";
import { debounce } from "../utils/debounce.js";
import Cookies from "js-cookie";

class SiteHeader {
    constructor(element) {
        this.el = element;
        this.init();

        this.setupResizeListener();
    }

    init() {
        this.updateHeaderHeight();
        this.updatePageNavigationHeight();
        this.updatePostSubNavigation();
        this.setupGoogleTranslate();
        this.setupSearchForm();
        this.setupHamburger();
        this.setupAnnouncement();
    }

    setupSearchForm() {
        const searchForm = document.querySelector(".site-header__search");

        if (!searchForm) {
            return;
        }

        new Disclosure(searchForm, {
            collapseOnEscape: true,
            collapseOnFocusout: true,
            focusWithinOnExpand: true,
            setHiddenAttribute: false,
        });
    }

    setupHamburger() {
        const hamurgerTriggers = document.querySelectorAll(".btn-hamburger");
        hamurgerTriggers.forEach((item) => {
            item.addEventListener("click", (e) => {
                hamurgerTriggers.forEach((item) => {
                    const child = item.querySelector(".hamburger");
                    item.style.display = "block";
                    if (child) {
                        child.classList.toggle("active");
                    }
                });
            });
        });
    }

    updateHeaderHeight() {
        document.body.style.removeProperty("--header-height");
        const headerHeight = this.el.offsetHeight;
        document.body.style.setProperty("--header-height", `${headerHeight}px`);
    }

    updatePageNavigationHeight() {
        const pageNavigation = document.querySelector(".section-navigation");
        const sectionNavigation = document.querySelector("#sectionNavigation");
        const pageNavigationClosed = sectionNavigation
            ? sectionNavigation.getAttribute("aria-hidden") === "true"
            : false;
        if (
            pageNavigation !== "undefined" &&
            pageNavigation !== null &&
            pageNavigationClosed === true
        ) {
            document.body.style.removeProperty("--page-navigation-height");

            // Show on load on desktop
            if (window.matchMedia("(min-width: 768px)").matches) {
                sectionNavigation.setAttribute("aria-hidden", "false");
                sectionNavigation.removeAttribute("hidden");
            }

            const pageNavigationHeight = pageNavigation.offsetHeight;
            document.body.style.setProperty(
                "--page-navigation-height",
                `${pageNavigationHeight}px`,
            );
        }
    }

    updatePostSubNavigation() {
        const postSubNavigation = document.querySelector(
            ".post-sub-navigation",
        );
        if (postSubNavigation !== "undefined" && postSubNavigation !== null) {
            document.body.style.removeProperty("--page-navigation-height");
            const postSubNavigationHeight = postSubNavigation.offsetHeight;
            document.body.style.setProperty(
                "--page-navigation-height",
                `${postSubNavigationHeight}px`,
            );
        }
    }

    setupGoogleTranslate() {
        const googleTranslateWrapper =
            document.querySelector(".translate-wrapper");
        const utilityMenu = document.querySelector(
            ".site-header__utility-menu",
        );
        const overlyHeader = document.querySelector(
            ".site-header-overlay__header",
        );
        const googleTranslateButton = document.querySelector(
            ".btn-google-translate",
        );
        const googleTranslateEl = document.querySelector(
            "#google_translate_element",
        );
        googleTranslateButton.addEventListener("click", () => {
            googleTranslateEl.style.display =
                googleTranslateEl.style.display === "none" ? "block" : "none";
            googleTranslateButton.classList.toggle("active");
        });

        if (window.matchMedia("(min-width: 992px)").matches) {
            utilityMenu.prepend(googleTranslateWrapper);
        } else {
            overlyHeader.prepend(googleTranslateWrapper);
        }
    }

    setupAnnouncement() {
        const announcementDialog =
            document.getElementById("announcementDialog");
        if (!announcementDialog) return;

        document.body.style.removeProperty("--announcement-height");

        setTimeout(() => {
            const announcementHeight = announcementDialog.offsetHeight;
            document.body.style.setProperty(
                "--announcement-height",
                `${announcementHeight}px`,
            );
        }, 50);

        if (!Cookies.get("viewed_announcement")) {
            announcementDialog.style.display = "flex";
            const announcementDialogButton =
                announcementDialog.querySelector("button");

            announcementDialogButton.addEventListener("click", () => {
                announcementDialog.setAttribute("aria-hidden", "true");
                document.body.style.removeProperty("--announcement-height");
            });

            setTimeout(() => {
                Cookies.set("viewed_announcement", true);
            }, 500);
        }
    }

    setupResizeListener() {
        window.addEventListener(
            "resize",
            debounce(() => {
                this.init();
            }, 300),
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector(".site-header");

    if (element) {
        new SiteHeader(element);
    }
});
